


























































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import ProductLocation from "../../../store/entities/products/product-location";
import Ref from "@/store/entities/ref";
import _ from "lodash";
import ViewCaseLabelSerials from "@/views/components/view-caselabel-serials.vue";
class viewProductLocationInfo {
  productName: string = "";
  productLocationId: number = 0;
  caseLabelCode: string = "";
  productId: number = 0;
  qty: number = 0;
}
class PageLocationRequest extends PageRequest {
  keyword: string = "";
  locationType: string = "";
}

@Component({
  components: { "view-serials": ViewCaseLabelSerials },
})
export default class SearchProductLocation extends AbpBase {
  namespace = "location";
  spinShow: boolean = false;

  get store() {
    return this.$store.state.location;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }

  get tenant() {
    return this.$store.state.session.tenant;
  }
  //filters
  pagerequest: PageLocationRequest = new PageLocationRequest();
  isShowInfo: boolean = false;
  productLocation: ProductLocation = new ProductLocation();
  locationTypes: Array<Ref> = new Array<Ref>();
  viewProductLocation: viewProductLocationInfo = new viewProductLocationInfo();
  viewSerialModelShow: boolean = false;
  canExport() {
    return (
      this.isTenant() &&
      !Util.isNull(this.productLocation.product) &&
      this.productLocation.product.productId > 0 &&
      this.productLocation.product.storageType === AppConsts.storageType.serial
    );
  }
  columns = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      width: 50,
    },
    {
      title: Util.L("Code"),
      key: "locationCode",
    },
    {
      title: Util.L("Client"),
      key: "clientName",
    },
    {
      title: Util.L("Type"),
      key: "locationTypeName",
    },
    {
      title: Util.L("Status"),
      key: "locationStatusText",
    },
    {
      title: Util.L("ConditionType"),
      key: "conditionTypeName",
    },
    {
      title: Util.L("AssetType"),
      key: "assetTypeName",
    },
    {
      title: Util.L("Qty"),
      slot: "qty",
      align: "right",
      width: 100,
    },
  ];
  showSerialPopup() {
    return (
      this.productLocation.product.storageType ===
        AppConsts.storageType.serial &&
      Util.isEmpty(this.productLocation.product.serialNo)
    );
  }
  async exportToExcel() {
    await this.$store.dispatch({
      type: `${this.namespace}/exportProducLocation`,
      data: {
        warehouseCode: this.tenant.tenancyName,
        locationType: this.pagerequest.locationType,
        keyword: this.pagerequest.keyword,
      },
    });
  }
  async getpage() {
    this.spinShow = true;
    try {
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
      await this.$store
        .dispatch({
          type: "location/searchLocationContainProduct",
          data: this.pagerequest,
        })
        .then((res) => {
          if (res.product == null) {
            this.isShowInfo = false;
            return;
          }
          this.isShowInfo = true;
          this.productLocation.product = res.product;
          this.productLocation.locations = res.locations.items;
          var startIndex = (this.currentPage - 1) * this.pageSize;
          let i = 1;
          _.forEach(this.productLocation.locations, (item) => {
            item.orderNo = startIndex + i;
            i++;
          });
          this.$store.state.location.totalCount = res.locations.totalCount;
        });
      this.spinShow = false;
    } catch (er) {
      this.productLocation = new ProductLocation();
      this.isShowInfo = false;
      this.spinShow = false;
    }
  }

  get loading() {
    return this.store.loading;
  }
  get pageSize() {
    return this.store.pageSize;
  }
  get totalCount() {
    return this.store.totalCount;
  }
  get currentPage() {
    return this.store.currentPage;
  }

  pageChange(page: number) {
    this.$store.commit(`${this.namespace}/setCurrentPage`, page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit(`${this.namespace}/setPageSize`, pagesize);
    this.getpage();
  }

  getPathThumbnailUrl(name: string) {
    return Util.getAppUrlImage(name);
  }

  getLocationTypes(re) {
    if (re.length > 0) {
      re.forEach((element) => {
        element.description = this.L(`${element.code}`);
      });
      re.unshift({
        code: `${AppConsts.allItemValue}`,
        description: this.L(AppConsts.All),
      });
      this.$set(this.pagerequest, "locationType", re[0].code);
      this.locationTypes = re;
    }
  }
  showSerials(index: number) {
    var location = this.productLocation.locations[index];
    this.viewProductLocation.productLocationId = location.productLocationId;
    this.viewProductLocation.caseLabelCode =
      this.productLocation.product.caseLabelCode;
    this.viewProductLocation.productName =
      this.productLocation.product.productName;
    this.viewProductLocation.productId = location.productId;
    this.viewProductLocation.qty = location.qty;
    this.viewSerialModelShow = true;
  }
  async created() {
    await this.$store
      .dispatch({
        type: "ref/getRefsForSelect",
        param: {
          tableName: AppConsts.tableRef.tableLocation.name,
          columnName: AppConsts.tableRef.tableLocation.column.type,
        },
      })
      .then((res) => {
        this.getLocationTypes(res);
      });
  }
}
